import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router";

import { useApplicationParameters } from "src/api/client-api/appParams/useApplicationParameters";
import { openFreshdeskTicketForm } from "src/plugins/freshdesk/freshdeskWidget";
import { isAppInPDFMode } from "src/utils/rendering";

import { ErrorPage, type ErrorPageKind } from "./ErrorPage";

type RouteErrorPageProps = {
    canContactSupport?: boolean;
};

export const getRouteErrorPageKind = (error: unknown): ErrorPageKind => {
    if (!isRouteErrorResponse(error)) {
        return "unexpected";
    }

    if (error.status === 401 || error.status === 403) {
        return "accessDenied";
    }

    if (error.status === 404) {
        return "notFound";
    }

    if (error.status === 500 || error.status === 503) {
        return "serviceUnavailable";
    }

    return "unexpected";
};

export const RouteErrorPage = (props: RouteErrorPageProps) => {
    const { canContactSupport = true } = props;
    const error = useRouteError();
    const navigate = useNavigate();
    const { applicationParameters } = useApplicationParameters();
    const kind = getRouteErrorPageKind(error);
    const canOpenContactSupport =
        canContactSupport && !isAppInPDFMode() && Boolean(applicationParameters?.freshdeskWidgetId);

    return (
        <ErrorPage
            kind={kind}
            onRetry={
                kind === "serviceUnavailable" || kind === "unexpected" ? () => window.location.reload() : undefined
            }
            onGoHome={kind === "notFound" || kind === "serviceUnavailable" ? () => navigate("/") : undefined}
            onContactSupport={kind === "unexpected" && canOpenContactSupport ? openFreshdeskTicketForm : undefined}
        />
    );
};
